import { AgnesModal, AgnesButton } from '@agnes/ui';
import { useConfirm } from '@/stores/useConfirm';

export function ConfirmDialog() {
  const { open, title, message, okLabel, cancelLabel, dataQa, respond } = useConfirm();
  return (
    <AgnesModal
      open={open}
      title={title}
      maxWidth="xs"
      onClose={() => respond(false)}
      data-qa={dataQa}
      footer={
        <div className="flex justify-end gap-3">
          <AgnesButton
            variant="secondary"
            data-qa={dataQa ? `${dataQa}-cancelar` : undefined}
            onClick={() => respond(false)}
          >
            {cancelLabel}
          </AgnesButton>
          <AgnesButton
            variant="primary"
            data-qa={dataQa ? `${dataQa}-confirmar` : undefined}
            onClick={() => respond(true)}
          >
            {okLabel}
          </AgnesButton>
        </div>
      }
    >
      <div
        className="px-6 py-4 text-agnes-text-primary"
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </AgnesModal>
  );
}
